import { Link } from 'react-router-dom';

interface CategoryCardProps {
  title: string;
  slug: string;
  description: string;
  icon: string;
  color: 'primary' | 'accent' | 'secondary';
  articleCount: number;
}

const colorMap = {
  primary: {
    bg: 'bg-primary-100/80',
    text: 'text-primary-700',
    hoverBg: 'hover:bg-primary-100',
    border: 'hover:border-primary-300/60',
    countBg: 'bg-primary-500',
  },
  accent: {
    bg: 'bg-accent-100/80',
    text: 'text-accent-700',
    hoverBg: 'hover:bg-accent-100',
    border: 'hover:border-accent-300/60',
    countBg: 'bg-accent-500',
  },
  secondary: {
    bg: 'bg-secondary-100/80',
    text: 'text-secondary-700',
    hoverBg: 'hover:bg-secondary-100',
    border: 'hover:border-secondary-300/60',
    countBg: 'bg-secondary-500',
  },
};

export default function CategoryCard({ title, slug, description, icon, color, articleCount }: CategoryCardProps) {
  const c = colorMap[color];
  return (
    <Link
      to={`/category/${slug}`}
      className={`block bg-background-50 rounded-lg border border-background-200/70 p-5 transition-all duration-300 ${c.border} ${c.hoverBg} group cursor-pointer`}
    >
      <div className={`w-12 h-12 flex items-center justify-center rounded-lg ${c.bg} ${c.text} mb-4 group-hover:scale-110 transition-transform duration-300`}>
        <i className={`${icon} text-xl`}></i>
      </div>
      <div className="flex items-center gap-2 mb-2">
        <h3 className="text-base font-semibold text-foreground-900 font-heading">
          {title}
        </h3>
        <span className={`text-xs text-white ${c.countBg} px-2 py-0.5 rounded-full whitespace-nowrap`}>
          {articleCount}篇
        </span>
      </div>
      <p className="text-sm text-foreground-600 line-clamp-2">
        {description}
      </p>
    </Link>
  );
}